import fs from "fs";
import React from "react";
import { GetStaticProps, GetStaticPropsResult } from "next";
import { BlogsList, SimpleLayout } from "@portaljs/core";
import clientPromise from "../../lib/mddb.mjs";
import computeFields from "../../lib/computeFields";
import UnstyledLayout from "@/layouts/unstyled";
import Blogs from 'components/blog/Blog'

export default function Blog({
  blogs, casestudies
}: any) {
  return (
    <UnstyledLayout>
      <Blogs blogs={blogs} casestudies={casestudies} />
    </UnstyledLayout>
  );
}

export async function getStaticProps() {
  const mddb = await clientPromise;

  const blogFiles = await mddb.getFiles({ folder: "blog" });
  const caseStudiesFiles = await mddb.getFiles({ folder: "showcase/case-studies" });

  const blogsMetadataPromises = blogFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const caseStudiesMetadataPromises = caseStudiesFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const blogsList = await Promise.all(blogsMetadataPromises);
  const caseStudiesList = await Promise.all(caseStudiesMetadataPromises);



  return {
    props: {
      meta: {
        title: "Datopian Blog | The Latest on Data Management & Open Data",
        description: "Get the latest insights on data management, open data, and innovative data solutions as we democratize the power of data globally.",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
      },
      blogs: blogsList,
      casestudies: caseStudiesList,
    },
  };
};
